import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const DonutChart = ({
  percentage = 0,
  title,
  innerRadius = 50,
  outerRadius = 90,
  isProgressTracker = false,
}) => {
  const safePercentage = Math.min(Math.max(percentage, 0), 100);

  const data = [
    {
      name: "Completed",
      value: safePercentage,
      color: "#4CDBFF",
    },
    {
      name: "Remaining",
      value: 100 - safePercentage,
      color: "#FF8B38",
    },
  ];

  return (
    <div className="relative flex justify-center items-center">
      <PieChart width={isProgressTracker ? 150 : 200} height={200}>
        <Pie
          data={data}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={90}
          endAngle={-270}
          paddingAngle={0}
          stroke="none"
          style={{ pointerEvents: "none" }}
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>

      <div className="absolute text-center">
        {/* <p className="text-sm text-[#222]">{title}</p> */}
        <p className="text-[20px] font-semibold text-[#6C6A6A]">
          {safePercentage}%
        </p>
      </div>
    </div>
  );
};

export default DonutChart;
